var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBalanceR(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 187,
    viewBox: "0 0 115 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.89 130.233C100.568 131.056 98.1489 131.443 95.7781 132.072C91.0849 133.282 86.3433 134.346 81.6017 135.459C75.07 137.055 68.5382 138.652 61.958 140.2C61.7645 140.249 61.571 140.346 61.3774 140.442",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4775 123.701C14.6873 123.314 12.9455 122.782 11.0102 122.927C8.25233 123.169 5.49447 123.265 2.78499 123.459C1.2851 123.556 0.849657 123.991 1.04319 125.443C1.04319 125.636 1.09157 125.781 1.28511 125.927C2.785 126.846 4.18811 128.007 6.17184 127.668C7.81688 127.378 9.5103 127.378 11.1553 127.185C12.4133 126.991 13.381 127.62 14.397 127.959C24.3157 131.249 34.2827 134.49 44.2497 137.684C46.9108 138.506 49.5235 139.474 52.1846 140.393C52.1846 140.877 52.1846 141.458 52.1846 142.038C53.0555 142.28 53.878 141.941 54.7005 142.232",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.31 128.152C100.374 128.975 98.294 129.265 96.2619 129.749C86.5852 132.12 76.9085 134.394 67.2318 136.813C65.5867 137.248 63.8933 137.587 62.2483 137.974",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.752 125.104C14.5906 125.975 16.526 126.459 18.4613 127.088C21.6546 128.153 24.7995 129.217 27.9928 130.233C35.8794 132.797 43.7659 135.362 51.7008 137.878",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.229 127.572C99.3585 128.298 98.1973 128.346 97.1812 128.588C93.4073 129.362 89.6818 130.379 85.9562 131.201C81.5049 132.217 77.0537 133.33 72.6024 134.394C69.3123 135.168 66.0222 135.943 62.7321 136.717C62.4902 136.765 62.2483 136.959 62.0548 137.055",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.558 126.024C21.7997 127.234 25.1382 128.202 28.4283 129.266C35.2987 131.492 42.2176 133.669 49.088 135.895C50.0557 136.233 51.1202 136.378 51.9911 136.911",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8777 156.796C56.6358 157.183 56.7809 157.57 56.7809 157.958C56.7809 162.119 56.8777 166.231 56.7325 170.392C56.6841 172.618 56.7809 174.892 56.5874 177.117C56.3938 179.295 56.539 181.52 56.539 183.746C56.539 184.423 56.4906 185.004 56.2003 185.585C54.9423 185.972 53.7811 185.536 52.5232 185.343C52.7167 181.569 52.8135 177.746 53.007 173.973C53.2005 170.199 53.4425 166.473 53.5392 162.699C53.5876 160.328 53.6844 157.958 53.9263 155.635C54.0231 154.474 54.4101 154.28 55.6197 154.377C56.3938 154.426 56.8777 155.055 56.8777 156.022C56.8777 156.264 56.6841 156.506 56.8777 156.7",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8931 153.119C66.4577 153.264 65.9738 153.216 65.49 153.216C58.0873 153.216 50.6846 153.216 43.3304 153.216",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M113.099 127.427C111.793 126.943 110.39 126.991 109.035 126.749C107.1 126.459 105.165 126.072 103.229 125.927C101.729 125.83 100.181 126.024 98.6812 126.459",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0229 156.7C58.0873 156.7 59.2002 156.7 60.2646 156.7C62.5386 156.7 64.8126 156.7 67.0867 156.7C67.6673 153.99 66.4577 151.764 65.8287 149.394C65.7319 149.103 65.49 149.007 65.1513 149.007C60.2646 149.007 55.3779 148.813 50.5395 148.958C48.9912 149.007 47.3462 148.813 45.7979 148.765C45.1689 148.765 44.8302 148.958 44.4916 149.587C43.1368 152.2 42.9917 153.022 43.4755 156.7C46.814 156.7 50.2008 156.7 53.5393 156.7",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6006 128.492C96.3103 126.943 97.0361 126.169 98.4392 126.798C100.181 127.572 101.971 127.718 103.81 127.911C104.874 128.008 105.89 128.25 106.955 128.395C108.019 128.54 109.084 128.637 110.196 128.976C110.148 129.701 110.293 130.427 110.051 131.153",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9776 124.864C16.0421 125.396 17.2033 125.638 18.3161 125.928C18.4612 125.299 18.558 124.718 18.2677 124.041C17.4936 124.186 16.7194 123.896 15.8485 124.331C15.4131 124.573 14.639 124.476 14.01 124.573C11.7359 124.767 9.41353 124.622 7.1395 125.105C6.36536 125.251 5.59123 125.009 4.8171 125.251C4.62356 126.025 4.72033 126.799 4.72033 127.573",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M102.987 128.153C103.229 128.782 103.084 129.411 102.939 130.137C104.923 130.476 106.858 130.718 108.793 131.202C110.729 131.685 112.132 130.621 113.68 129.895C114.261 129.605 114.164 128.492 113.535 127.524C112.615 128.347 111.358 128.347 110.293 128.831",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1197 139.281C56.781 139.959 57.1681 140.588 57.1197 141.265C56.9745 143.781 57.0229 146.297 57.0229 148.813",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1359 139.281C54.7005 142.378 54.6037 145.571 54.3134 148.668",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5393 134.878C52.4265 135.12 52.62 136.281 52.1846 137.007C51.8943 137.539 51.2169 138.265 51.7975 138.942C52.2814 139.474 53.0071 139.039 53.6361 138.942C54.3135 138.845 54.9424 139.039 55.6198 139.087C57.0229 139.184 58.4261 139.039 59.7808 139.087C61.0872 139.087 61.2807 139.378 61.1839 140.684C61.1839 140.974 61.1839 141.216 61.1839 141.506C61.2323 141.99 60.9904 142.135 60.5066 142.232C59.4421 142.377 58.4261 142.329 57.3616 142.232",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.329 139.282C61.5709 138.991 62.0063 139.379 62.2482 139.04C62.2482 137.782 61.5709 136.669 61.3774 135.459C61.2322 134.637 60.4097 134.879 59.7807 134.879",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1036 185.052C54.9424 183.89 54.6037 183.842 52.8619 184.568",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10764 123.944C2.88177 124.525 3.84944 124.67 4.67196 125.106",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1714 125.009C11.6875 125.589 12.123 126.364 11.8327 126.993",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2844 43C29.2528 45.8233 28.004 48.6467 27.7868 51.6329C27.5153 54.7277 27.081 57.8768 27.1353 61.0259C27.1896 65.1523 27.6782 69.2245 28.1669 73.2966C28.4926 75.957 28.3298 78.6175 27.0267 81.1151",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0146 94.3594C74.3177 96.1511 75.2407 98.2686 76.5438 100.115C77.0867 100.82 77.684 101.363 78.4984 101.689C80.1272 102.286 81.1045 103.698 82.1361 104.947C83.3306 106.467 84.4708 107.987 85.5024 109.616C86.4797 111.191 87.8371 112.44 89.1945 113.634C90.0089 114.394 91.1491 114.557 92.1807 114.666C93.5381 114.829 94.2982 115.589 94.5154 116.783C94.9498 119.281 96.0357 121.453 97.8274 123.299C98.0446 123.516 98.0446 123.733 98.2075 123.95C99.1848 125.308 99.1305 125.308 97.7188 126.285",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1483 34.1484C36.2026 37.4604 36.637 40.7724 37.7229 43.9215C38.3744 45.8219 37.4514 47.505 36.6913 49.1339C36.094 50.3826 35.4425 51.5771 35.0081 52.9345C34.8995 53.2603 34.8452 53.6403 34.8995 53.9661C35.2796 56.4094 34.8452 58.8527 34.0851 61.1331C32.9992 64.3908 32.8363 67.757 32.2934 71.069C31.9133 73.3494 32.2934 75.4669 33.9765 77.2044C34.628 77.9102 34.7909 78.8332 34.7909 79.8105C34.7909 80.8964 34.7366 81.9823 35.171 83.0682C35.2796 83.3397 35.3882 83.8826 34.9538 84.0998C34.5738 84.2627 34.1937 83.9912 33.9222 83.7198C33.3793 83.1768 33.325 82.471 33.1621 81.7652C33.0535 81.3308 33.1078 80.8421 32.5105 80.8421C32.4562 80.8421 32.402 80.8964 32.402 80.9507C32.402 81.005 32.402 81.0593 32.402 81.0593",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9246 101.419C64.4903 103.482 63.8387 105.491 64.2731 107.663C64.9789 111.626 63.6215 115.21 61.9927 118.739C60.7982 121.291 59.7123 123.897 58.735 126.558C58.3006 127.806 57.9206 129.164 58.3549 130.575C58.6264 131.444 58.5721 132.476 58.3006 133.399C58.0835 134.05 58.0835 134.756 58.3549 135.353C58.6807 136.276 58.3006 136.819 57.5405 137.036C56.889 137.199 56.4003 137.634 55.7488 137.742",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8792 101.526C68.7252 103.698 70.5713 105.87 73.0146 107.39C74.9692 108.639 76.3808 110.485 78.3355 111.734C81.2674 113.688 84.3622 115.426 87.077 117.706C87.9457 118.412 88.6515 119.227 89.2488 120.095C90.1175 121.29 90.9862 122.484 92.1264 123.462C93.3209 124.493 93.5924 125.959 93.9181 127.371",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6361 23.0723C46.3557 23.7781 44.4011 25.2441 42.1207 25.9499C39.7317 26.6557 37.4514 27.5245 35.8768 29.5877C34.7366 31.1079 33.6507 32.7368 32.1847 33.9856C31.8047 34.3113 31.859 34.6914 31.859 34.9086C32.0219 37.2976 31.0988 39.3608 30.0672 41.424C29.7415 42.0212 29.7958 42.5099 30.2301 42.8356C32.239 44.3559 34.3023 45.7676 37.017 45.7133C37.9943 45.659 38.4287 46.0933 38.7001 46.9078C39.2974 48.6452 39.8403 50.4369 40.5462 52.1201C42.718 57.0609 43.8039 62.2733 44.6726 67.4856C44.8898 68.6801 44.3468 70.0917 44.9441 71.1233C46.1386 73.1865 47.0616 75.304 47.2245 77.693L47.7674 78.236C48.3104 78.236 48.799 78.236 49.2877 78.236C49.5591 79.3219 50.1021 80.2449 50.265 81.3308C50.3193 81.8194 50.5364 82.5253 51.1337 82.9053C52.3825 83.7198 52.8168 84.9142 52.9797 86.2716C53.1969 88.1176 54.1742 89.6922 55.3687 91.0496C56.4546 92.2984 56.6718 93.5471 56.4003 95.1217C56.1288 96.9134 55.8031 98.7595 55.5859 100.606C55.423 101.746 55.5859 102.886 55.9117 103.972C56.346 105.492 56.1288 106.958 55.7488 108.424C54.88 111.682 54.6086 114.994 54.7172 118.306C54.7715 119.663 54.6086 121.02 54.7715 122.323C55.0429 124.984 54.1199 127.319 52.8711 129.436C51.9481 131.011 51.7852 132.694 51.6223 134.323C51.5138 135.409 51.4595 136.494 51.1337 137.58C51.0251 137.96 51.0251 138.395 51.3509 138.775",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6361 23.6164C46.6272 26.1683 47.7131 29.7517 50.9708 30.8919C55.2601 32.4665 57.9206 31.0548 60.5811 28.0143C61.5584 26.8741 61.2869 25.2452 60.0924 24.1593C59.7666 23.8336 59.8209 23.725 60.0924 23.5078",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6013 80.7871C28.6556 84.3706 29.3071 87.6826 32.0219 90.3973C32.6191 90.1801 32.782 89.6915 32.5105 88.9856C32.4562 88.8228 32.3476 88.6056 32.2391 88.4427C30.936 86.9224 31.0446 85.0764 31.0446 83.2304C31.0446 82.4703 31.1532 81.8187 31.6961 81.2758",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0414 43.8125C80.996 46.6358 82.9506 49.4049 85.1224 52.0653C86.3169 53.5313 86.8055 55.2687 85.8825 57.2776C85.3396 58.4178 85.231 59.7209 84.2537 60.6439",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9968 90.4524C69.2682 90.3438 69.594 90.2895 69.1053 89.9095C67.2593 88.6064 65.1961 87.9006 62.97 87.6834C61.3412 87.5205 59.7123 87.4119 58.1378 87.9549C56.889 88.3892 56.8347 88.6064 56.9433 90.0181C56.9976 90.7782 56.9976 91.6469 56.5632 92.3528",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1328 8.08678C62.427 7.10947 61.8297 6.13216 61.5583 4.93768C61.0696 2.76588 57.3775 0.539778 54.2827 1.08273C52.9254 1.29991 51.3508 1.24562 50.2649 2.33152",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1475 18.0215C48.0389 19.3789 48.6362 20.6276 48.7991 21.9307C49.2334 24.9712 51.1881 26.7087 53.8485 27.9575C54.9887 28.5004 56.1832 28.3375 57.0519 27.6317C58.1921 26.763 59.278 25.7857 59.7124 24.2654",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6345 31.0547C74.9148 33.6066 76.1093 36.7557 77.4124 39.7962C77.9011 40.9364 78.8241 41.8594 79.2585 43.0539C76.6523 46.5831 71.5486 48.1033 69.4854 46.4745C71.2771 43.9226 71.82 40.8821 72.363 37.8416",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4498 13.8418C61.5041 14.8191 61.124 15.6878 60.6896 16.6108C60.5268 16.9366 60.2553 17.2081 60.4182 17.6424C61.0154 19.4885 60.3096 21.2802 60.0381 23.1262C61.8841 24.4293 63.8388 25.6781 65.7391 26.9269C67.0965 27.8499 68.5081 28.5557 69.9198 29.2073C70.7342 29.5874 71.4401 30.076 72.1459 30.5647",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1783 69.875C59.0608 72.3183 58.0835 75.1416 57.7577 78.345C57.5405 80.2453 56.889 82.1457 56.4546 84.1003C56.1831 85.2948 56.0202 86.435 55.8031 87.6295C55.6402 88.5525 55.8574 89.1497 56.7261 89.4755",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5713 35.4512C70.5713 37.7316 70.8971 39.9577 70.5713 42.238C70.4627 43.0525 69.9198 43.8669 70.2998 44.7356",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6353 54.2373C62.2642 54.726 63.9473 54.4002 65.5762 54.5088C66.3906 54.5631 67.205 54.5631 68.0738 54.5088C69.1597 54.4002 69.8655 54.726 69.8112 56.1376C67.5851 56.1376 65.3047 55.5404 62.97 55.2689",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M47.876 7.16309C46.5186 8.41187 45.4327 9.76924 45.5413 11.7239C45.5956 13.0812 45.5413 14.4929 46.3014 15.7417",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6929 57.877C79.4214 58.6371 78.607 58.5285 78.1184 58.6914C77.141 59.0714 77.1411 59.5601 77.3582 60.3202C77.5211 60.9175 77.7926 61.569 77.7383 62.1663C77.6297 63.9037 78.7156 64.4466 80.073 64.9353C80.5616 65.0982 81.3218 65.0982 81.5389 65.9126C81.7561 66.5641 82.462 66.347 82.9506 66.2927C84.1451 66.1298 85.1224 64.8267 85.0138 63.5779",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7552 81.6016C27.1896 82.3074 27.081 83.1218 26.7009 83.6648C25.7779 85.0221 25.9408 86.4338 26.2123 87.8455C26.4295 88.8228 26.9724 88.2255 27.3525 87.9541",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6483 46.9082C68.7253 49.2972 68.1824 51.7405 68.4538 54.3466",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8744 47.3428C73.3403 49.2974 74.6977 51.3063 76.4894 52.8809C78.2812 54.4554 78.3355 56.41 78.6612 58.4189",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1781 72.4824C60.0922 74.3285 59.0063 76.1202 57.9204 77.9662",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6313 8.62891C54.4457 9.11756 54.9343 9.93199 55.9659 10.2578C57.1061 10.5835 58.0834 10.1492 59.1151 9.932",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3597 10.4219C54.7713 11.4535 56.2916 11.0191 57.8119 10.8019C58.0834 10.7476 58.3548 10.7476 58.572 10.6933",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0705 9.93262C48.799 11.6158 48.2018 13.1903 47.6045 14.7649C47.3331 15.525 48.0389 16.0137 47.876 16.7195",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3322 11.2354C59.7666 12.9185 59.8209 14.7102 60.0924 16.4477",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0883 16.4482C53.3055 18.0771 53.3055 19.6516 52.9797 21.3891C53.6856 21.4977 54.3371 22.0406 55.1515 21.6605",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5582 101.148C61.5582 102.832 60.7981 104.298 60.3637 105.818",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2106 8.62891C50.8078 10.5292 52.2195 11.4523 54.1198 11.778",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3881 40.1758C35.551 41.9132 36.474 43.3249 37.3427 44.7366",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7252 57.8759C71.2228 57.4415 73.1231 58.9618 73.0688 61.2422C73.0688 61.6222 72.9059 61.7851 72.6344 62.0023",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3331 15.2544C47.0616 15.2544 46.7358 15.2001 46.5729 15.5258C45.7585 16.6117 46.4644 19.055 47.7674 19.5437C47.876 19.598 48.0389 19.598 48.1475 19.4351",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3946 102.725C74.3176 103.973 74.8606 105.331 74.6977 106.905",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4504 3.14551C48.6903 4.12282 48.256 5.3173 48.0388 6.51179C47.9845 6.94615 47.8759 7.48909 48.4188 7.81486",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4846 59.7213C81.919 59.667 82.299 59.8842 82.6248 60.1014C83.1678 60.4272 83.4392 60.9701 83.385 61.5131C83.3307 61.9474 83.0592 62.4361 82.5162 62.5447C81.7018 62.6533 80.996 63.0876 80.1815 63.2505C79.53 63.4134 79.2585 63.2505 79.1499 62.8161C79.0413 62.4361 78.8785 61.9474 79.4757 61.6217C80.1272 61.2959 80.7788 61.1873 81.4303 60.9701",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0138 65.4219C85.9911 66.5621 84.7423 66.6707 84.2537 67.105C83.4936 67.7566 83.2221 67.2679 83.0592 66.5621",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5162 58.9053C83.9279 59.9912 84.688 61.4571 85.0138 63.1946C84.0907 64.3891 82.6248 64.552 81.4846 65.3121",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0608 14.6019C57.9749 14.5476 56.8891 14.439 55.9117 15.1448",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1353 83.6641C27.2982 83.9355 27.5154 84.2613 27.4068 84.5871C26.8096 85.9988 27.5697 86.9761 28.4927 87.8448C29.1986 88.5506 29.1443 89.6365 29.7415 90.3423C30.5559 90.4509 30.6102 89.7994 30.8274 89.3107",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M70.68 89.4209C70.4628 90.7783 69.5398 91.2126 68.3453 91.2669",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3914 136.331C54.5543 136.82 55.0429 137.2 55.0429 137.743C53.4684 138.394 53.4141 138.394 53.0883 136.603",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8939 15.2545C50.9166 15.0916 49.9393 14.4401 48.9077 14.8744",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M49.722 78.0717C50.8622 77.6917 51.568 76.7143 52.5997 76.1171L53.1426 75.5742C54.1742 74.434 55.2058 73.2938 56.2917 72.2079L56.8347 71.6649C60.1467 68.0271 64.1645 65.2581 68.4538 62.8148C68.8339 62.5977 69.2139 62.4348 69.6483 62.2719C72.4716 61.2403 73.3403 61.6746 74.209 64.6066C74.9149 67.0498 74.9149 69.4931 74.209 71.8821C73.4489 74.2711 73.286 76.8229 72.4173 79.2119C71.8744 80.6779 71.6572 82.1438 71.6572 83.7727C71.6029 85.1844 71.7658 86.8132 71.0056 88.2249C70.7342 88.7135 70.9514 89.0393 71.2771 89.4194C72.2544 90.6682 73.286 91.8626 74.3719 93.0571C71.0057 95.3918 68.6167 98.4323 66.5535 101.853C65.359 101.364 65.0875 100.713 65.359 99.5182C65.9019 96.8035 66.9335 94.2516 68.0737 91.754C68.3452 91.1568 68.5624 90.5053 68.8338 89.908",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5697 87.0869C27.1896 88.1185 28.1669 88.7701 28.0041 89.5845C28.6013 89.8017 28.6556 89.2587 28.9814 89.2587",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6329 125.636C96.7956 126.07 96.3073 126.505 96.6329 126.939C97.6096 126.722 97.6096 126.722 97.1755 125.094",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6945 23.4521C54.9886 23.5064 54.2828 23.5607 53.6313 23.5607",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2877 24.2666C48.799 24.9181 49.0162 25.624 49.1791 26.3298",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9509 57.9817C71.385 57.0049 70.8424 56.5166 70.0284 56.1367",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9066 72.7539C48.4182 73.4593 47.8756 74.0562 47.0616 74.4361",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9077 9.28125C49.2877 10.2586 50.0479 10.6929 50.9709 10.9644",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4497 7.59766C61.9381 8.08603 62.6435 8.08603 63.2947 8.24883",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0243 70.3643C50.753 71.0154 49.9933 71.2867 49.722 71.9379",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9101 63.6309C79.9644 64.0107 80.0186 64.3905 80.0186 64.8246",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4384 126.396C95.4384 127.59 95.4384 127.59 96.198 127.319",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2552 24.374C60.0382 24.7539 60.1467 25.1337 60.1467 25.5678",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M57.269 135.518C57.486 135.897 57.7031 136.277 57.9201 136.711",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6944 136.059C55.8572 136.547 56.4541 136.71 56.6169 137.252",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6467 84.209C27.0266 84.4803 26.5382 84.9687 26.918 85.24",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5152 126.396C94.4067 126.776 94.2439 127.21 94.1353 127.59C94.3524 127.59 94.7865 127.916 95.1663 127.59",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3896 53.4229C78.5523 53.857 78.064 54.0198 78.0097 54.3453",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9067 19.0543C62.1555 19.5973 63.0785 19.1086 63.5129 17.7512C63.7844 16.8825 63.7844 15.9595 63.35 15.308C62.6985 14.3306 62.9157 13.5705 63.2414 12.6475C63.7844 11.1815 63.8387 9.71557 63.2414 8.19531",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6669 14.6036C61.9925 14.5494 62.3723 14.7122 62.6979 14.4951",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8938 17.4808C51.1337 17.8609 50.3193 17.7523 49.5049 17.2637",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7488 17.2623C56.4546 17.6967 57.3776 17.4252 58.3549 16.9365",
    stroke: "#2B4B8E",
    strokeWidth: 0.724204,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalanceR);
export default __webpack_public_path__ + "static/media/balance-r.ab14541a9b5d0351245c6ced26f06181.svg";
export { ForwardRef as ReactComponent };